import { Etiquette } from '../entities';
import * as yup from 'yup';

export const schemaEtiquette = yup.object<Partial<Etiquette>>({
    name: yup.string().required(),
    est_public: yup.string().nullable(),
    description: yup.string().nullable(),
}) as yup.ObjectSchema<Partial<Etiquette>>;
